import React from 'react'
import {Constants, Label, useContainerDimensionsContext} from '@therms/atalaya'
import './RecordFields.css'
import {RecordField} from './RecordField'
import {RPCDocs} from '@therms/react-modules'
import classNames from 'classnames'

interface ItemRecordFieldsProps {
  record: RPCDocs.Records.GetRecordProfile.v1.Record
}

function ItemRecordFields({record}: ItemRecordFieldsProps) {
  const {
    viewport: {width: mainWidth},
  } = useContainerDimensionsContext()

  let layout = 'Xxl'
  if (mainWidth < Constants.Breakpoint.Sm.width) {
    layout = 'Sm'
  } else if (mainWidth < Constants.Breakpoint.Xl.width) {
    layout = 'Xl'
  }

  return (
    <div className="grid grid-cols-6">
      <div
        className={classNames({
          'col-span-2': layout === 'Xxl',
          'col-span-3': layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Name</Label>
        <RecordField fieldType="text" value={record.fields.name} />
      </div>

      <div
        className={classNames({
          'col-span-2': layout === 'Xxl',
          'col-span-3': layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Brand</Label>
        <RecordField fieldType="text" value={record.fields.brand} />
      </div>

      <div
        className={classNames({
          'col-span-2': layout === 'Xxl',
          'col-span-3': layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Style</Label>
        <RecordField fieldType="text" value={record.fields.style} />
      </div>

      <div
        className={classNames({
          'col-span-2': layout === 'Xxl',
          'col-span-3': layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Color</Label>
        <RecordField fieldType="select" value={record.fields.color} />
      </div>

      <div
        className={classNames({
          'col-span-2': layout === 'Xxl',
          'col-span-3': layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Size</Label>
        <RecordField fieldType="text" value={record.fields.size} />
      </div>

      <div
        className={classNames({
          'col-span-2': layout === 'Xxl',
          'col-span-3': layout === 'Xl',
          'col-span-6': layout === 'Sm',
        })}
      >
        <Label className="label">Status</Label>
        <RecordField fieldType="select" value={record.fields.status} />
      </div>

      <div className="col-span-6">
        <Label className="label">Additional Info</Label>
        <RecordField fieldType="textarea" value={record.fields.additional} />
      </div>
    </div>
  )
}

export {ItemRecordFields}
